import { defineMessages } from 'react-intl';

/** i18n messages for YouTube connect mode actions and their helper descriptions. */
export const youtubeConnectMessages = defineMessages({
  connectBasic: {
    id: 'socialExport.youtube.connectBasic',
    defaultMessage: 'Conectar en modo básico',
  },
  connectBasicDescription: {
    id: 'socialExport.youtube.connectBasicDescription',
    defaultMessage: 'Solo permite subir videos',
  },
  connectAdvanced: {
    id: 'socialExport.youtube.connectAdvanced',
    defaultMessage: 'Conectar en modo avanzado',
  },
  connectAdvancedDescription: {
    id: 'socialExport.youtube.connectAdvancedDescription',
    defaultMessage: 'Permite añadir videos a listas de reproducción y también borrarlos',
  },
});
